module.exports = __webpack_public_path__ + "img/zoho-inactive-even-line.275c5650.svg";